(function() {
    'use strict';

    angular
        .module('2017SiteDesign')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $log) {
        $rootScope.modals = {};
        $rootScope.logger = function(errormessage) {
            $log.error(errormessage);
        }
        $rootScope.toggleModal = function(modal, event) {
            if (angular.isUndefined(event) || event.target === event.currentTarget) {
                if (modal) {
                    $rootScope.modals[modal] = !$rootScope.modals[modal];
                    $rootScope.modalOpen = $rootScope.modals[modal];
                } else {
                    for (var key in $rootScope.modals) {
                        $rootScope.modals[key] = false;
                    }
                    $rootScope.modalOpen = false;
                }
            }
        }
    }

})();